import React, { Component } from 'react';

class BlueActionBtn extends Component {
    constructor(props) {
        super(props);
        this.state={
            visibility:props.visible,
            disability:props.disable,
            text:props.text,
            onclick:props.onClick


        }
    }
    
    render() {
        const {visibility,disability,text} =  this.state
        return (
            <>
                 {visibility ?  <button className='blueactionbtn' disabled={!disability} onClick={this.state.onclick}>
                 <span className='bluebtntext'>{text}</span><span className='bluebtnarrow'> > </span> </button> :null}
            </>
        );
    }
}

export default BlueActionBtn;